import { AlpineComponent } from 'alpinejs';

const Survey = (): AlpineComponent => ({
  getSurveyResults() {
    const submitBtn = this.form.querySelector('button[type="submit"]');
    submitBtn.style.display = 'none';
    fetch(`/api/survey-results/${this.formHandle}`, {
      headers: {
        Accept: 'application/json'
      }
    })
      .then((result) => {
        return result.json();
      })
      .then((result) => {
        Object.keys(result).forEach((key, i) => {
          const value = result[key];
          const resultNode = document.createTextNode(`${value}%`);
          this.radios[i].querySelector('input').disabled = true;
          this.radios[i]
            .querySelector('.survey__progress')
            .style.setProperty('--progress', value);
          this.radios[i]
            .querySelector('.survey__progress-number')
            .appendChild(resultNode);
        });
      });
  },
  updateLocalstorage() {
    if (this.submittedSurveys) {
      const parsedItems = JSON.parse(this.submittedSurveys);
      parsedItems.push(this.formHandle);
      localStorage.setItem('surveys', JSON.stringify(parsedItems));
    } else {
      const surveys = [this.formHandle];
      localStorage.setItem('surveys', JSON.stringify(surveys));
    }
  },
  handleIntersect() {
    if (this.submittedSurveys) {
      const parsedItems = JSON.parse(this.submittedSurveys);
      if (parsedItems.includes(this.formHandle)) this.getSurveyResults();
    }
  },
  init() {
    this.formHandle = this.$root.dataset.formHandle;
    this.form = this.$root.querySelector('form');
    this.radios = this.form.querySelectorAll('.fui-radio');
    this.submittedSurveys = localStorage.getItem('surveys');

    this.radios.forEach((radio: HTMLDivElement) => {
      const progressWrapper = document.createElement('div');
      progressWrapper.className = 'survey__progress';
      const progressNumber = document.createElement('span');
      progressNumber.className = 'survey__progress-number';
      progressWrapper.appendChild(progressNumber);

      radio.appendChild(progressWrapper);
    });

    this.form.addEventListener('onAfterFormieSubmit', () => {
      this.updateLocalstorage();
      this.getSurveyResults();
    });
  }
});

export default Survey;
